import { NO_STOCK_ID, nearestAspectRatio, type Garment, type ShootSettings } from '@studio/shared';

import type { Translate } from './i18n';

/** What every roll starts from, whichever way it was set up. */
export const DEFAULT_SETTINGS: ShootSettings = {
  aspectRatio: '2:3',
  lightingId: 'high-key-soft',
  backdropId: 'seamless-brown',
  gradeId: 'clean-digital',
  filmStockId: NO_STOCK_ID,
  grain: 0,
  customBackdrop: '',
  poseIds: [],
  variantsPerPov: 1,
  details: '',
  styleNotes: '',
  // No judge and no automatic second attempt: the studio reshoots by hand what it does not like.
  qualityThreshold: 0,
  maxRetriesPerShot: 1,
  retryMode: 'auto',
  copySpace: 'none',
  useGarmentReferences: true,
  useModelReferences: true,
  expression: 'auto',
  accessories: [],
  accessoryNotes: '',
  stylingMode: 'as-uploaded',
  attitude: 'editorial',
  // The stronger renderer: the quick one does not hold a face or an embroidery.
  fidelity: 'max',
};

/**
 * What a roll is called when nobody names it — the name it is stored under,
 * built from the studio's language rather than the browser's.
 */
export function defaultName(garments: Garment[], t: Translate, stamp: (value: Date) => string): string {
  const first = garments[0]?.label?.trim();
  const today = stamp(new Date());
  return first ? `${first} — ${today}` : `${t('shoot.untitledRoll')} — ${today}`;
}

/** The studio ratio closest to a photograph's own shape. */
export function nearestRatio(width?: number, height?: number): ShootSettings['aspectRatio'] {
  return nearestAspectRatio(width, height);
}
